import type { IntlShape } from 'react-intl';

import type { ExecutionsHistoryWarnings } from '@src/models/interfaces/executionsHistoryDashboard.interface';

const WARNING_KEYS: Array<keyof ExecutionsHistoryWarnings> = ['missingTimestamps', 'unassigned', 'missingExecution'];

/** Explains the orders the report counted differently or left out; empty when there are none. */
export const getWarningMessages = (intl: IntlShape, warnings?: ExecutionsHistoryWarnings): string[] =>
  WARNING_KEYS.filter(key => (warnings?.[key] ?? 0) > 0).map(key =>
    intl.formatMessage({ id: `dashboards.tasks.summary.warning.${key}` }, { count: warnings![key] }));
